// Shared helpers for rendering match scores across the app.
// A match score is stored either as a human-readable tennis string
// (e.g. "6-4, 7-6 (5)" or legacy "6-4, 7-6(4)") or the sentinel "WALKOVER".

export const WALKOVER = 'WALKOVER';

export function isWalkover(score) {
  return typeof score === 'string' && score.trim().toUpperCase() === WALKOVER;
}

// Normalize one set segment to the canonical tennis display format:
//   "7-6 (5)"   for tiebreak sets
//   "10-5"      for a match tiebreak (third-set super tiebreak)
//   "6-4"       for a regular set
// Accepts legacy "7-6(5)" (no space) as well as spaced variants.
function formatSegment(raw) {
  const s = raw.trim();
  // With tiebreak — two numbers then optional space and parenthesized number
  let m = s.match(/^(\d+)\s*-\s*(\d+)\s*\(\s*(\d+)\s*\)$/);
  if (m) return `${m[1]}-${m[2]} (${m[3]})`;
  // Plain "A-B"
  m = s.match(/^(\d+)\s*-\s*(\d+)$/);
  if (m) return `${m[1]}-${m[2]}`;
  // Unknown format — return as-is so we never silently hide data.
  return s;
}

// Display helper used by every score-rendering surface.
// Returns "WALKOVER" for walkovers, the canonical tennis string for normal
// scores, or the `fallback` when the score is empty.
export function formatScore(score, fallback = '—') {
  if (isWalkover(score)) return WALKOVER;
  if (!score || !score.trim()) return fallback;
  return score
    .split(',')
    .map(formatSegment)
    .filter(Boolean)
    .join(', ');
}
